import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Form extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls  = classNames({
      "weui-form": true
    }, className);

    return <div className={ cls } { ...others }>
      { children }
    </div>;
  }
}

export class FormArea extends PureComponent {
  render() {
    // type: text, control, tips, opr, extra
    const { children, className, type, ...others } = this.props;
    const cls = classNames({
      [`weui-form__${type}-area`]: true
    }, className);

    return <div className={ cls } { ...others }>
      { children }
    </div>;
  }
}

export class FormTitle extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-form__title": true
    }, className);

    return <h2 className={ cls } { ...others }>
      { children }
    </h2>;
  }
}

export class FormDesc extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-form__desc": true
    }, className);

    return <div className={ cls } { ...others }>
      { children }
    </div>;
  }
}

export class FormTips extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-form__tips": true
    }, className);

    return <p className={ cls } { ...others }>
      { children }
    </p>;
  }
}
